import {
  createBrowserRouter,
  RouterProvider,
  useOutlet,
} from "react-router-dom";

import routeNames from "../constants/route-names";
import PrivateRoute from "../components/private-route/private-route";
import MainNavigationLayout from "../components/main-navigation-layout/main-navigation-layout";
import LogIn from "./login/login";
import HomePage from "./home/home";
import ErrorPage from "./error/error-page";
import CreateNotification from "./create-notification/create-notification";
import AiChats from "./ai-chats/ai-chats";
import AiChatConversation from "./ai-chat-conversation/ai-chat-conversation";
import AiChatConversationNonAdmin from "./ai-chat-conversation-nonadmin/ai-chat-conversation-nonadmin";
import MentorshipPrograms from "./mentorship-programs/mentorship-programs";
import MentorshipProgramAdd from "./mentorship-program-add/mentorship-program-add";
import MentorshipProgramDetails from "./mentorship-program-details/mentorship-program-details";
import MentorshipProgramEdit from "./mentorship-program-edit/mentorship-program-edit";
import Grit from "./grit/grit";
import ManageUsers from "./manage-users/manage-users";

// import NotFound from "./not-found/not-found";
import AuthContextProvider from "../context/AuthContext";
import MentorshipCreateRelationships from "./mentorship-create-relationship/mentorship-create-relationship";

export const AuthLayout = () => {
  const outlet = useOutlet();

  return <AuthContextProvider>{outlet}</AuthContextProvider>;
};

const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    children: [
      {
        path: routeNames.LOGIN,
        element: <LogIn />,
        errorElement: <ErrorPage />,
      },
      {
        element: <MainNavigationLayout />,
        children: [
          {
            index: true,
            element: (
              <PrivateRoute>
                <HomePage />
              </PrivateRoute>
            ),
          },
          {
            path: routeNames.CREATE_NOTIFICATION,
            element: (
              <PrivateRoute requireWorkspaceAdmin>
                <CreateNotification />
              </PrivateRoute>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: routeNames.MANAGE_USERS,
            element: (
              <PrivateRoute requireWorkspaceAdmin>
                <ManageUsers />
              </PrivateRoute>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: routeNames.MENTORSHIP,
            element: (
              <PrivateRoute requireWorkspaceAdmin>
                <MentorshipPrograms />
              </PrivateRoute>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: routeNames.MENTORSHIP_ADD,
            element: (
              <PrivateRoute requireWorkspaceAdmin>
                <MentorshipProgramAdd />
              </PrivateRoute>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: routeNames.MENTORSHIP_DETAILS,
            element: (
              <PrivateRoute requireWorkspaceAdmin>
                <MentorshipProgramDetails />
              </PrivateRoute>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: routeNames.MENTORSHIP_EDIT,
            element: (
              <PrivateRoute requireWorkspaceAdmin>
                <MentorshipProgramEdit />
              </PrivateRoute>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: routeNames.MENTORSHIP_RELATIONSHIP_ADD,
            element: (
              <PrivateRoute requireWorkspaceAdmin>
                <MentorshipCreateRelationships />
              </PrivateRoute>
            ),
            errorElement: <ErrorPage />,
          },
          {
            path: routeNames.GRIT,
            element: (
              <PrivateRoute>
                <Grit />
              </PrivateRoute>
            ),
            errorElement: <ErrorPage />,
          },
          // AI Chat routes
          {
            path: routeNames.AI_CHATS,
            children: [
              {
                index: true,
                element: (
                  <PrivateRoute requireWorkspaceAdmin>
                    <AiChats />
                  </PrivateRoute>
                ),
              },
              {
                path: "new",
                element: (
                  <PrivateRoute requireWorkspaceAdmin>
                    <AiChatConversation />
                  </PrivateRoute>
                ),
              },
              {
                path: ":id",
                element: (
                  <PrivateRoute requireWorkspaceAdmin>
                    <AiChatConversation />
                  </PrivateRoute>
                ),
              },
            ],
            errorElement: <ErrorPage />,
          },
          // Non-admin AI Chat routes
          {
            path: routeNames.AI_CHATS_NONADMIN,
            children: [
              {
                index: true,
                element: <AiChatConversationNonAdmin />,
              },
              {
                path: "new",
                element: <AiChatConversationNonAdmin />,
              },
              {
                path: ":chatId",
                element: <AiChatConversationNonAdmin />,
              },
              {
                path: ":chatId/:messageId",
                element: <AiChatConversationNonAdmin />,
              },
            ],
            errorElement: <ErrorPage />,
          },
        ],
      },
    ],
  },
]);

function Root() {
  return <RouterProvider router={router} />;
}

export default Root;
